import { render, staticRenderFns } from "./uOttawa1321Lab4ModelsAndStereoanalysis.vue?vue&type=template&id=8c10adca&"
import script from "./uOttawa1321Lab4ModelsAndStereoanalysis.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Lab4ModelsAndStereoanalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VContainer,VRow})
